<div class="assigned-list">
  <div class="assigned-status-tabs" role="tablist" aria-label="Assigned note status">
    <button
      type="button"
      role="tab"
      [attr.aria-controls]="openPanelId"
      [attr.aria-selected]="selectedStatus() === 'open'"
      (click)="selectedStatus.set('open')"
    >
      To Do
      @if (openUnreadCount()) {
        <span>{{ openUnreadCount() }}</span>
      }
    </button>
    <button
      type="button"
      role="tab"
      [attr.aria-controls]="resolvedPanelId"
      [attr.aria-selected]="selectedStatus() === 'resolved'"
      (click)="selectedStatus.set('resolved')"
    >
      Resolved
      @if (resolvedUnreadCount()) {
        <span>{{ resolvedUnreadCount() }}</span>
      }
    </button>
  </div>

  <div class="assigned-results">
    @if (accessDenied()) {
      <p class="assigned-state" role="alert">You no longer have access to these assigned notes.</p>
    } @else {
      @if (anyError()) {
        <p class="assigned-state" role="alert">
          Could not refresh assigned notes. <button type="button" (click)="reload()">Retry</button>
        </p>
      }
      @if (anyLoading() && !pinned().length && !open().length && !resolved().length) {
        <p class="assigned-state" role="status">Loading assigned notes…</p>
      }
      @if (!anyLoading() && !anyError() && !pinnedCount() && !openCount() && !resolvedCount()) {
        <p class="assigned-state">No matching assigned notes</p>
      }

      @for (note of pinned(); track note.id) {
        @if (note.pendingReview) {
          <span class="px-2 text-xs" aria-label="Review awaiting your decision">Review</span>
        }
        @if (note.pendingAssignment) {
          <span class="px-2 text-xs" aria-label="Assignment awaiting acceptance">Assignment</span>
        }
        <app-note
          class="assigned-pinned"
          [class.assigned-unread]="!!note.collaboration?.viewerAssignmentUid && !note.collaboration?.viewerSeenAt"
          [item]="note"
          (onClick)="openNote.emit(note)"
          (onDoubleClick)="doubleClickNote.emit(note)"
        />
      }
      @if (pinned().length < pinnedCount()) {
        <button
          class="assigned-more-pinned"
          type="button"
          [disabled]="pinnedLoadingMore() || pinnedLoading()"
          (click)="loadMorePinned()"
        >
          {{ pinnedLoadingMore() ? 'Loading pinned notes…' : 'More pinned notes' }}
        </button>
      }

      <section
        [id]="openPanelId"
        role="tabpanel"
        aria-label="To Do assigned notes"
        [hidden]="selectedStatus() !== 'open'"
      >
        @for (row of datedOpen(); track row.note.id) {
          @if (row.heading) {
            <div class="assigned-date-heading">{{ row.heading }}</div>
          }
          @if (row.note.pendingReview) {
            <span class="px-2 text-xs" aria-label="Review awaiting your decision">Review</span>
          }
          @if (row.note.pendingAssignment) {
            <span class="px-2 text-xs" aria-label="Assignment awaiting acceptance">Assignment</span>
          }
          <app-note
            [class.assigned-unread]="
              !!row.note.collaboration?.viewerAssignmentUid && !row.note.collaboration?.viewerSeenAt
            "
            [item]="row.note"
            (onClick)="openNote.emit(row.note)"
            (onDoubleClick)="doubleClickNote.emit(row.note)"
          />
        }
      </section>

      <section
        [id]="resolvedPanelId"
        role="tabpanel"
        aria-label="Resolved assigned notes"
        [hidden]="selectedStatus() !== 'resolved'"
      >
        @for (row of datedResolved(); track row.note.id) {
          @if (row.heading) {
            <div class="assigned-date-heading">{{ row.heading }}</div>
          }
          @if (row.note.pendingReview) {
            <span class="px-2 text-xs" aria-label="Review awaiting your decision">Review</span>
          }
          @if (row.note.pendingAssignment) {
            <span class="px-2 text-xs" aria-label="Assignment awaiting acceptance">Assignment</span>
          }
          <app-note
            [class.assigned-unread]="
              !!row.note.collaboration?.viewerAssignmentUid && !row.note.collaboration?.viewerSeenAt
            "
            [item]="row.note"
            (onClick)="openNote.emit(row.note)"
            (onDoubleClick)="doubleClickNote.emit(row.note)"
          />
        }
      </section>
    }
  </div>

  @if (!accessDenied()) {
    <app-pagination2
      class="assigned-footer border-t border-border"
      [page]="activePage()"
      [pageSize]="pageSize"
      [totalItems]="activeCount()"
      [loading]="activeLoading()"
      (pageChange)="changeActivePage($event)"
      (refresh)="reload()"
    />
  }
</div>
